(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kompresso-bunion-usa-pdp"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('kompresso-bunion-usa')) return;

  class KompressoBunionUSA extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      const dataElement = this.querySelector('[data-kp-product-data]');
      if (!dataElement) return;
      try {
        this.productData = JSON.parse(dataElement.textContent);
      } catch (error) {
        return;
      }
      this.abortController = new AbortController();
      const eventOptions = { signal: this.abortController.signal };
      this.variantControl = this.querySelector('[name="id"]');
      this.quantityInput = this.querySelector('[name="quantity"]');
      this.planControl = this.querySelector('[data-kp-selling-plan]');
      this.submitButton = this.querySelector('[name="add"]');
      this.quantityStatus = this.querySelector('[data-kp-quantity-status]');
      this.variantStatus = this.querySelector('[data-kp-variant-status]');
      this.mediaPanels = [...this.querySelectorAll('[data-kp-media-panel]')];
      this.thumbnails = [...this.querySelectorAll('[data-kp-thumb]')];
      this.variantControl?.addEventListener('change', () => this.syncVariant(true), eventOptions);
      this.planControl?.addEventListener('change', () => this.syncPrice(), eventOptions);
      this.quantityInput?.addEventListener('change', () => this.normalizeQuantity(), eventOptions);
      this.quantityInput?.addEventListener('blur', () => this.normalizeQuantity(), eventOptions);

      this.querySelectorAll('[data-kp-quantity-change]').forEach(button => {
        button.addEventListener('click', () => {
          if (!this.quantityInput) return;
          const direction = Number(button.dataset.kpQuantityChange);
          const increment = Number(this.quantityInput.step) || 1;
          const value = Number(this.quantityInput.value) || Number(this.quantityInput.min) || 1;
          this.quantityInput.value = String(value + direction * increment);
          this.normalizeQuantity();
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }, eventOptions);
      });

      this.thumbnails.forEach((button, index) => {
        button.addEventListener('click', () => this.showMedia(button.dataset.mediaId, true), eventOptions);
        button.addEventListener('keydown', event => {
          const directions = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 };
          let nextIndex;
          if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.thumbnails.length - 1;
          else if (Object.hasOwn(directions, event.key)) {
            nextIndex = (index + directions[event.key] + this.thumbnails.length) % this.thumbnails.length;
          }
          if (nextIndex === undefined) return;
          event.preventDefault();
          const nextButton = this.thumbnails[nextIndex];
          nextButton.focus({ preventScroll: true });
          this.showMedia(nextButton.dataset.mediaId, true);
          nextButton.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, eventOptions);
      });

      const faqItems = [...this.querySelectorAll('[data-kp-faq]')];
      faqItems.forEach(item => {
        item.addEventListener('toggle', () => {
          if (item.open) faqItems.forEach(other => { if (other !== item) other.open = false; });
        }, eventOptions);
      });

      this.querySelectorAll('[data-kp-back-to-product]').forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault();
          const target = this.variantControl?.tagName === 'SELECT' ? this.variantControl : this.submitButton;
          if (!target) return;
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.querySelector('[data-kp-purchase]')?.scrollIntoView({ behavior, block: 'center' });
          target.focus({ preventScroll: true });
        }, eventOptions);
      });

      this.syncVariant(false);
      const selectedPanel = this.mediaPanels.find(panel => !panel.hidden);
      if (selectedPanel) this.mountMedia(selectedPanel);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.mediaPanels?.forEach(panel => panel.querySelectorAll('video').forEach(video => video.pause()));
    }

    get currentVariant() {
      return this.productData.variants.find(variant => String(variant.id) === this.variantControl?.value);
    }

    syncVariant(userInitiated) {
      const variant = this.currentVariant;
      if (!variant) return;
      const labels = this.productData.labels;
      const limited = variant.available && variant.quantity.max !== null && variant.quantity.max < variant.quantity.min;
      const noPlans = this.productData.requiresSellingPlan && variant.sellingPlans.length === 0;
      const purchasable = variant.available && !limited && !noPlans;
      if (this.quantityInput) {
        this.quantityInput.min = String(variant.quantity.min);
        this.quantityInput.step = String(variant.quantity.increment);
        if (variant.quantity.max === null) this.quantityInput.removeAttribute('max');
        else this.quantityInput.max = String(variant.quantity.max);
        this.quantityInput.disabled = !purchasable;
        this.normalizeQuantity();
      }

      if (this.submitButton) {
        this.submitButton.disabled = !purchasable;
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        const label = this.submitButton.querySelector('[data-kp-add-label]');
        if (label) label.textContent = purchasable ? labels.addToCart : limited ? labels.cartLimit : labels.soldOut;
        const icon = this.submitButton.querySelector('.kp-icon');
        if (icon) icon.hidden = !purchasable;
      }
      if (this.variantStatus) {
        this.variantStatus.textContent = limited ? labels.cartLimitNote : !purchasable ? labels.soldOutNote : '';
      }
      this.syncPlans(variant);
      this.syncPrice();

      if (userInitiated) {
        if (variant.mediaId) this.showMedia(String(variant.mediaId), true);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        history.replaceState(history.state, '', url);
        this.dispatchEvent(new CustomEvent('kompresso:variant-change', {
          bubbles: true,
          detail: { productId: this.productData.id, variantId: variant.id, available: purchasable }
        }));
      }
    }

    syncPlans(variant) {
      if (!this.planControl) return;
      const previousValue = this.planControl.value;
      const options = [];
      if (!this.productData.requiresSellingPlan) {
        options.push(new Option(this.productData.labels.oneTime, ''));
      }
      variant.sellingPlans.forEach(plan => options.push(new Option(plan.name, String(plan.id))));
      this.planControl.replaceChildren(...options);
      if (options.some(option => option.value === previousValue)) this.planControl.value = previousValue;
      else if (options.length) this.planControl.value = options[0].value;
      this.planControl.disabled = options.length === 0;
    }

    syncPrice() {
      const variant = this.currentVariant;
      if (!variant) return;
      const plan = variant.sellingPlans.find(item => String(item.id) === this.planControl?.value);
      const price = plan || variant;
      const currentPrice = this.querySelector('[data-kp-price]');
      const comparePrice = this.querySelector('[data-kp-compare]');
      if (currentPrice) currentPrice.textContent = price.price;
      if (comparePrice) {
        comparePrice.textContent = price.compareAt || '';
        comparePrice.hidden = !price.compareAt;
      }
    }

    normalizeQuantity() {
      const input = this.quantityInput;
      if (!input) return;
      const min = Number(input.min) || 1;
      const step = Number(input.step) || 1;
      const max = input.hasAttribute('max') ? Number(input.max) : Infinity;
      let value = Number(input.value);
      if (!Number.isFinite(value)) value = min;
      value = min + Math.floor((Math.max(min, value) - min) / step) * step;
      if (max >= min && value > max) value = min + Math.floor((max - min) / step) * step;
      input.value = String(value);
      this.querySelectorAll('[data-kp-quantity-change]').forEach(button => {
        const next = value + Number(button.dataset.kpQuantityChange) * step;
        button.disabled = input.disabled || next < min || next > max;
      });
      const note = this.querySelector('[data-kp-rule-note]');
      if (note) {
        note.textContent = min > 1 || step > 1
          ? this.productData.labels.quantityRule.replace('%min%', String(min)).replace('%step%', String(step))
          : '';
      }
      if (this.quantityStatus) {
        this.quantityStatus.textContent = this.productData.labels.quantityChanged.replace('%quantity%', String(value));
      }
    }

    mountMedia(panel) {
      const template = panel.querySelector('template[data-kp-media-template]');
      if (template) {
        template.replaceWith(template.content.cloneNode(true));
      }
      const externalTemplate = panel.querySelector('template[data-kp-external-template]');
      if (externalTemplate && !panel.querySelector('iframe')) panel.append(externalTemplate.content.cloneNode(true));
    }

    showMedia(mediaId, announce) {
      const selected = this.mediaPanels.find(panel => panel.dataset.mediaId === String(mediaId));
      if (!selected) return;
      this.mediaPanels.forEach(panel => {
        panel.hidden = panel !== selected;
        if (panel !== selected) {
          panel.querySelectorAll('video').forEach(video => video.pause());
          const template = panel.querySelector('[data-kp-external-template]');
          if (template) panel.querySelectorAll('iframe').forEach(frame => frame.remove());
        }
      });
      this.mountMedia(selected);
      this.thumbnails.forEach(button => {
        button.setAttribute('aria-current', String(button.dataset.mediaId === String(mediaId)));
      });
      if (announce) {
        const status = this.querySelector('[data-kp-gallery-status]');
        const index = this.mediaPanels.indexOf(selected) + 1;
        if (status) status.textContent = this.productData.labels.mediaChanged
          .replace('%number%', String(index)).replace('%total%', String(this.mediaPanels.length));
      }
    }
  }

  customElements.define('kompresso-bunion-usa', KompressoBunionUSA);
})();


  } catch(e) { console.error(e); }
})();
})();
